import { createFileRoute } from "@tanstack/react-router";
import { LoginFormPage } from "@/components/auth/login-form";

type SigninSearchParams = {
  email?: string;
  redirect?: string;
};

export const Route = createFileRoute("/auth/signin")({
  component: RouteComponent,

  validateSearch: (search: Record<string, unknown>): SigninSearchParams => {
    return {
      email: search.email as string | undefined,
      redirect: search.redirect as string | undefined,
    };
  },
});

function RouteComponent() {
  const { email, redirect } = Route.useSearch();
  return (
    <div className="bg-topography flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-4xl">
        <LoginFormPage email={email} redirect={redirect} />
      </div>
    </div>
  );
}
